/* eslint-disable @typescript-eslint/no-magic-numbers */
import { string } from 'utils/validation';

export default {
  adminCode: string()
    .minLength(4, 'Admin code must be atleast 4 alphanumeric characters')
    .required('Admin code is required'),
  programCode: string()
    .minLength(4, 'Program code must be atleast 4 characters long')
    .required('Program code is required'),
  password: string()
    // .addTest(
    //   (value: unknown) => /^(?=.*\d).{6,}$/.test(value as string),
    //   'Password must be at least 8 characters long and include at least 1 number',
    // )
    .minLength(6, 'Password must be at least 6 characters long')
    .required('Password is required'),
};
